exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Mixins\n */\n.new-doc .uk-button {\n  font-size: 15px; }\n\n.new-doc .doc-error {\n  font-size: 14px;\n  margin-top: 15px;\n  color: red; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/docs/new-doc/new-doc.component.scss
// module id = ../../../../../src-admin/app/components/docs/new-doc/new-doc.component.scss
// module chunks = main